import { render } from "./ImportBackupOffering.vue?vue&type=template&id=2e828c24&scoped=true"
import script from "./ImportBackupOffering.vue?vue&type=script&lang=js"
export * from "./ImportBackupOffering.vue?vue&type=script&lang=js"

import "./ImportBackupOffering.vue?vue&type=style&index=0&id=2e828c24&scoped=true&lang=less"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e828c24"]])

export default __exports__